import React__default from 'react';
import classnames from 'classnames';
import { MediaQuery } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { powerToFloat } from '../../ContactLensesUtils.js';
import { getEyeLabel, getAttributeLabel } from '../../utils.js';
import { LabelWithTooltip } from '../LabelWithTooltip/LabelWithTooltip.js';
import PrescriptionDropdown from '../PrescriptionDropdown/PrescriptionDropdown.js';
import { SelectElement } from '../SelectElement/SelectElement.js';
import { SelectWrapper } from '../SelectWrapper/SelectWrapper.js';

const PowerSelector = ({ attributes , isActive , hasError , className , id , activeFilters , foundProduct , handleAttributeChange , options , initialValue  })=>{
    const intl = useIntl();
    const isMobile = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const positiveOptions = options.filter((power)=>powerToFloat(power) >= 0
    );
    const negativeOptions = options.filter((power)=>powerToFloat(power) <= 0
    );
    negativeOptions.reverse() // 🙈 mutation; reversed for the UI (eg render 0 - -5 instead of -5 - 0)
    ;
    const selectElementClass = classnames('power-selector__select', {
        'power-selector__select--error': hasError && !foundProduct && isActive
    }, className);
    const eyeLabel = getEyeLabel(intl, id);
    const attributeLabel = getAttributeLabel(intl, 'power');
    return !isMobile ? /*#__PURE__*/ React__default.createElement(SelectWrapper, {
        key: "power"
    }, /*#__PURE__*/ React__default.createElement(LabelWithTooltip, {
        type: "power",
        id: id
    }), /*#__PURE__*/ React__default.createElement(PrescriptionDropdown, {
        className: selectElementClass,
        options: options,
        title: `${attributeLabel} ${eyeLabel}`,
        leftColumnOptions: negativeOptions,
        rightColumnOptions: positiveOptions,
        placeholder: initialValue,
        onChange: ({ value  })=>handleAttributeChange('power', value)
        ,
        disabled: !isActive,
        "aria-invalid": hasError,
        "data-t": "prescription-power"
    })) : /*#__PURE__*/ React__default.createElement(SelectElement, {
        attribute: "power",
        isActive: isActive,
        hasError: hasError,
        id: id,
        activeFilters: activeFilters,
        foundProduct: foundProduct,
        handleAttributeChange: handleAttributeChange,
        attributes: attributes
    });
};

export { PowerSelector };
//# sourceMappingURL=PowerSelector.js.map
